// extracted by mini-css-extract-plugin
module.exports = {"googleBtn":"GoogleButton_googleBtn__VfadR","googleBtn__icon":"GoogleButton_googleBtn__icon__cN1IV"};